import { takeEvery, call, put, fork } from 'redux-saga/effects';
import * as actions from '../ducks/visitor';
import * as api from '../services/api';
// import { toast } from 'react-toastify';
import toast from '../components/Toastify';
// import { load, loaded } from 'ducks/loading';

function* getVisitorsEs(action) {
  try {
    // yield put(load());
    const res = yield call(api.POST, '/getVisitorsEs', action.data);
    if (res.status == 'success') {
      yield put(actions.successVisitorsEs(res.data));
    }
    else if (res.status == 'not_found') {
      toast.warning(res.m);
    }
    // yield put(loaded());
  }
  catch (error) {
    // yield put(actions.userLoginError(true));
  }
}

export function* watch() {
  yield takeEvery(actions.GET_VISITORS_ES, getVisitorsEs);
}

export default function* rootSaga() {
  yield [
    fork(watch)
  ];
}


// WEBPACK FOOTER //
// ./src/sagas/visitor.js